import React from 'react';
import { BackButton } from './back-button';
import { ScrollIndicator } from './scroll-indicator';
import { cn } from '@/lib/utils';

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  showBackButton?: boolean;
  backTo?: string;
}

export function PageLayout({
  children,
  className,
  showBackButton = true,
  backTo = "/"
}: PageLayoutProps) {
  return (
    <div className={cn(
      "min-h-screen pt-20 px-4 bg-gradient-to-br from-purple-50 via-pink-50 to-purple-100",
      className
    )}>
      <div className="max-w-6xl mx-auto space-y-8">
        {showBackButton && <BackButton to={backTo} />}
        {children}
      </div>
      <ScrollIndicator />
    </div>
  );
}